import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

// Auth credentials (for basic protection)
const VALID_CREDENTIALS = {
  username: 'qrac',
  password: 'sifretina',
};

const AUTH_KEY = 'toyo-admin-auth';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if already authenticated
    const authData = sessionStorage.getItem(AUTH_KEY);
    if (authData) {
      try {
        const { username, timestamp } = JSON.parse(authData);
        // Session expires after 24 hours
        if (username === VALID_CREDENTIALS.username && Date.now() - timestamp < 24 * 60 * 60 * 1000) {
          setIsAuthenticated(true);
        } else {
          sessionStorage.removeItem(AUTH_KEY);
        }
      } catch {
        sessionStorage.removeItem(AUTH_KEY);
      }
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (username: string, password: string): boolean => {
    if (username === VALID_CREDENTIALS.username && password === VALID_CREDENTIALS.password) {
      sessionStorage.setItem(AUTH_KEY, JSON.stringify({
        username,
        timestamp: Date.now(),
      }));
      setIsAuthenticated(true);
      return true;
    }
    return false;
  };

  const handleLogout = () => {
    sessionStorage.removeItem(AUTH_KEY);
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="app loading-screen">
        <div className="loading-content">
          <div className="loading-spinner" />
          <span className="loading-text">INITIALIZING<span className="cursor">_</span></span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return <Dashboard onLogout={handleLogout} />;
}

export default App;
